module.exports = __webpack_public_path__ + "img/Forma 8 copia 3.99f03352.svg";